import withRouter from '@common/withRouter'
import { IRouterProps } from '@Interface/Login'
import React from 'react'
import { RiArrowLeftWideFill } from 'react-icons/ri'

interface PageHeaderProps {
    title: string;
    onBack?: () => void;
}

const PageHeader: React.FC<IRouterProps & PageHeaderProps> = ({ router, title, onBack = () => router.navigate(-1) }) => {

    return (
        <header className="sticky top-0 z-20">
            <div className="flex relative h-12 px-2 py-2 justify-between items-center bg-white">
                <RiArrowLeftWideFill className="text-4xl absolute cursor-pointer" onClick={onBack} />
                <h4 className="page-header">
                    {title}
                </h4>
            </div>
        </header>
    )
}

export default withRouter(PageHeader)